module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAABAElEQVQYGW3Bv0rUAQAH8O/5BDoopRdOkjRpNriIQ6A4OHUo9gqhQYuTRqCTBCJBPoKD4CqCIOfiJvUIXkjZ0F/l9MBPN9wPT/PzSUGnZZ9cuvLZW525zVOnqioGPPHSoZrh3NDnzDslgxYteqzkvTO9Kdi0m5j3145t517pcOBjCmpmlDU8T5MpV3pVnKTg2jNTvqfFLxNGXaegZtYjDWNpMqmhbM6XFKzbS7xRt2VL3evEvo0U9Ls0lhixbMlQYlxdOTd8cJA2qjbSzkMXJtJi0oUHuc2ao7Q4spa79PhtOk2m/dGd/1lxrKTk2Gruo8sPCxb81JX7qfjmqxdp8w8eDb2DS+SgHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/address1.png
// module id = lIl0
// module chunks = 1